<template>
  <el-dialog title="详情" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <el-descriptions :column="1">
      <el-descriptions-item label="订单类型">{{orderStatus(form.dataType)}}</el-descriptions-item>
      <el-descriptions-item label="交易单号">{{(form.payResponse && form.payResponse.newbizContent && form.payResponse.newbizContent.termrefnum) || (form.payResponse && form.payResponse.termrefnum)}}</el-descriptions-item>
      <el-descriptions-item label="退款金额(元)">{{form.payMoney}}</el-descriptions-item>
      <el-descriptions-item label="到账时间">{{form.payTime}}</el-descriptions-item>
      <el-descriptions-item label="推送成功时间">{{form.sendLog && form.sendLog.createdTime}}</el-descriptions-item>
      <el-descriptions-item label="推送状态">
        <el-tag type="" effect="dark" v-if="form.isOk">推送成功</el-tag>
        <el-tag type="danger" effect="dark" v-else>推送失败</el-tag>
      </el-descriptions-item>
      <!-- <el-descriptions-item label="请求参数">{{form.requestParameter}}</el-descriptions-item> -->
      <el-descriptions-item label="返回参数" v-if="form.returnParameter">{{form.returnParameter}}</el-descriptions-item>
    </el-descriptions>
    <template v-if="sendLog">
      <el-descriptions :column="2">
        <el-descriptions-item label="凭证编码">{{sendLog.dto && sendLog.dto.ExternalCode}}</el-descriptions-item>
        <el-descriptions-item label="凭证日期"> {{formatDate(sendLog.dto && sendLog.dto.VoucherDate)}}</el-descriptions-item>
        <el-descriptions-item label="城市公司"> {{form.sendLog && form.sendLog.cityCompanyName}}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="sendLog.dto && sendLog.dto.Entrys">
        <el-table-column label="科目" prop="Account.Code" align="center" />
        <el-table-column label="金额" prop="AmountCr" align="center" />
        <el-table-column label="客户编码" prop="AuxInfos.AuxAccCustomer.Code" align="center" />
        <el-table-column label="备注" prop="Summary" align="center" />
      </el-table>
    </template>
    <template v-if="sendLog1">
      <el-descriptions :column="2">
        <el-descriptions-item label="凭证编码">{{sendLog1.dto && sendLog1.dto.ExternalCode}}</el-descriptions-item>
        <el-descriptions-item label="凭证日期"> {{formatDate(sendLog1.dto && sendLog1.dto.VoucherDate)}}</el-descriptions-item>
        <el-descriptions-item label="城市公司"> {{form.sendLog1 && form.sendLog1.cityCompanyName}}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="sendLog1.dto && sendLog1.dto.Entrys">
        <el-table-column label="科目" prop="Account.Code" align="center" />
        <el-table-column label="金额" prop="AmountCr" align="center" />
        <el-table-column label="客户编码" prop="AuxInfos.AuxAccCustomer.Code" align="center" />
        <el-table-column label="备注" prop="Summary" align="center" />
      </el-table>
    </template>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
export default {
  data() {
    return {
      form: {},
      formVisible: false,
      formRules: {
      },
      sendLog: null,
      sendLog1: null,
    }
  },
  created() {

  },
  computed: {
    orderStatus() {
      return function (val) {
        switch (val) {
          case 201:
            return "使用现金支付订单取消到余额";
            break;
          case 202:
            return "售后退零售价";
            break;
          case 203:
            return "余额订单取消";
            break;
          case 204:
            return "零售价订单取消";
            break;
          case 205:
            return "赠送账户订单取消";
            break;
          default:
            return "类型错误";
            break;
        }
      }

    }
  },
  methods: {
    handleUpdate(row) {
      this.form = { ...row }
      this.sendLog = row.sendLog && row.sendLog.requestParameter ? JSON.parse(row.sendLog.requestParameter) : null;
      this.sendLog1 = row.sendLog1 && row.sendLog1.requestParameter ? JSON.parse(row.sendLog1.requestParameter) : null;
      this.formVisible = true
    },
    formatDate(date) {
      if (!date)  return ''
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
